import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useEnterOrSpaceKeyDownHandler } from "@circle-react/hooks/useEnterOrSpaceKeyDownHandler";

interface EntityMentionChipProps {
  href?: string;
  label: string;
  onClick?: () => void;
  prefix: "@" | "#";
}

export const EntityMentionChip = ({
  prefix,
  label,
  href,
  onClick,
}: EntityMentionChipProps) => {
  const handleKeyDown = useEnterOrSpaceKeyDownHandler<HTMLSpanElement>(() =>
    onClick?.(),
  );
  const chipClass = classNames(
    "bg-info-light text-primary inline-flex items-center rounded-md px-1 py-0.5 text-sm font-normal leading-5",
    { "cursor-pointer": Boolean(href ?? onClick) },
  );
  const children = `${prefix}${label}`;

  if (href) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={chipClass}>
        {children}
      </a>
    );
  }

  return (
    <span
      contentEditable={false}
      {...(onClick && {
        onClick,
        onKeyDown: handleKeyDown,
        role: "button",
        tabIndex: 0,
      })}
      className={chipClass}
    >
      {children}
    </span>
  );
};
